export default __webpack_public_path__ + "assets/front/scss/user-profile.cf30a6cf8770763266f5bfa372280320.css";